import { ActivityIndicator, FlatList, Text, View } from "react-native";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { AppColors } from "../../../../utility/AppColors";
import NotificationDetails from "./NotificationPopup/NotificationDetails";
import { MobileNotificationDetails } from "./NotificationPopup/MobileNotificationDetails";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { ShowLoader } from "../../../../common/ShowLoader";
import { getLoginData } from "../../../../utility/AppStoreData";
import { toast } from "react-toastify";
import {
  StackActions,
  useFocusEffect,
  useNavigation,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { handleApiError } from "../../../../services/errorHandler";
import NoDataFound from "../../../../Components/NoDataFound";
import { ScreenBGGradientView } from "../../../../common/CommonView";
import { NotificationHeader } from "./NotificationHeader";
import ChallengeItem from "./ChallengeItem";
import NotificationSkeleton from "../../../../Components/skeleton-components/NotificationSkeleton";
import { AppImages } from "../../../../utility/AppImages";
import CreateEventTooltip from "../../../../Components/home-common-components/CreateEventTooltip";
import { KeyboardAvoidingView } from "react-native";
import { TouchableWithoutFeedback } from "react-native";
import { Keyboard } from "react-native";
import { base_url, endpoints } from "../../../../Api/configs";
import { useNotifications } from "../../../../context/NotificationContext";
import Header from "../Common/Header";
import { parseResponseBody } from "../../../../services/apiClient";
import { ScrollView } from "react-native-gesture-handler";
import EventsDetailsUpdatedModal from "../../Event/UpdateEventsPopup/EventsDetailsUpdatedModal";
import ChangesApprovedModal from "../../Event/UpdateEventsPopup/ChangesApprovedModal";
import ChangesRejectedModal from "../../Event/UpdateEventsPopup/ChangesRejectedModal";
import CornfirmPurchaseBeltModal from "../BeltScreens/CornfirmPurchaseBeltModal";
import BeltPurchaseSuccessModal from "../BeltScreens/BeltPurchaseSuccessModal";
import ChallengeAcceptModal from "./NotificationPopup/ChallengeAcceptModal";
import {
  fetchPaymentBeltExchange,
  fetchUserBalance,
} from "../../../../services/profileAPI";
import {
  NOTIFICATION_ACTION_TYPES,
  NOTIFICATION_CATEGORIES,
} from "../../../../utility/types/NotificationConfig";
import {
  BELT_MEDAL_TYPES,
} from "../../../../config/notificationConfig";
import { useNotificationList } from "../../../../hooks/useNotificationList";
import { useNotificationCounts } from "../../../../hooks/useNotificationCounts";
import {
  getPendingChallengeAccept,
  clearPendingChallengeAccept,
  storePendingChallengeAccept,
} from "../../../../utility/urlUtils";

export default function Notifications({ route }) {
  const {
    selectedButton: paramSelectedButton,
    session,
    selectedTab,
    highlightNotificationId,
  } = route.params || {};
  const navigation = useNavigation();
  const deviceSize = useDeviceSize();

  const {
    notifications: managedNotifications,
    loading: hookLoading,
    pagination,
    unreadCounts: hookUnreadCounts,
    actions: { fetchNotifications, markAsRead, markAsSeen, markAsSeenById, sendInvite, updateUnreadCounts, addRealTimeNotification, updateNotificationStatus }
  } = useNotificationList();

  const [showUpdateEventNotification, setShowUpdateEventNotification] =
    useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  const [challengeItem, setChallengeItem] = useState(null);
  const [accessToken, setAccessToken] = useState("");

  // Add count refresh functionality for socket integration (after accessToken declaration)
  const { refreshCounts } = useNotificationCounts(accessToken);
  const { refreshNotificationCounts } = useNotifications(); // For header/sidebar count sync

  // Combined refresh function that updates both notification systems
  const refreshAllNotificationCounts = useCallback(async () => {
    try {
      console.log('🔄 Refreshing all notification counts...');
      // Refresh both notification count systems in parallel
      await Promise.all([
        refreshCounts && refreshCounts(),
        refreshNotificationCounts && refreshNotificationCounts()
      ]);
      console.log('✅ All notification counts refreshed successfully');
    } catch (error) {
      console.error('❌ Error refreshing notification counts:', error);
    }
  }, [refreshCounts, refreshNotificationCounts]);
  const [challengeID, setChallengeID] = useState("");
  // Track if we should open challenge popup after belt purchase
  const [pendingChallengeAfterBelt, setPendingChallengeAfterBelt] = useState(false);
  const [changeToCallOutTooltip, setChangeToCallOutTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [selectedButton, setSelectedButton] = useState("I've Organised");
  const [changeCostTooltipPosition, setChangeCostTooltipPosition] = useState({
    top: 0,
    left: 0,
  });
  const [showPendingNotifications, setShowPendingNotifications] =
    useState(false);
  const [changeCostTooltip, setChangeCostTooltip] = useState(false);
  const { showModal, newNotification, updateNotification, setNotifications, trackTabVisit } =
    useNotifications();

  // Derived state from hook-managed notifications (move to top for proper scope)
  const arrChallengeList = managedNotifications.challenges || [];
  const arrWatchingList = managedNotifications.watching || [];
  const arrIveOrganizedList = managedNotifications.organized || [];

  // Use hook's unread counts directly

  // markAsSeen function to call API when switching tabs
  const handleMarkAsSeen = useCallback(async (category: string) => {
    if (accessToken) {
      await markAsSeen(accessToken, category);
    }
  }, [accessToken, markAsSeen]);
  const [confirmCheckInLoader, setConfirmCheckInLoader] = useState(false);
  const [challengeDetails, setChallengeDetails] = useState(null);
  const [highlightedNotificationId, setHighlightedNotificationId] = useState(highlightNotificationId || null);
  const [showEventsDetailsUpdatedModal, setShowEventsDetailsUpdatedModal] =
    useState(false);
  const [updatedEventDetails, setUpdatedEventDetails] = useState(null);
  const [previousEventDetails, setPreviousEventDetails] = useState(null);
  const [updatedEventEventId, setUpdatedEventEventId] = useState("");
  const [updatedEventNotificationId, setUpdatedEventNotificationId] =
    useState("");
  const [showChangesApprovedModal, setShowChangesApprovedModal] =
    useState(false);
  const [showChangesRejectedModal, setShowChangesRejectedModal] =
    useState(false);
  const [showChangesLoader, setShowChangesLoader] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [platformStatus, setPlatformStatus] = useState({
    YouTube: "Not connected",
    Twitch: "Not connected",
  });

  // Use configuration-based belt medals with additional properties
  const [arrBeltMedalType, setArrBeltMedalType] = useState(() => {
    return BELT_MEDAL_TYPES.map((belt, index) => ({
      ...belt,
      isAvailableAmountSelected: belt.id === 0 ? 1 : 0,
      isSelected: belt.id === 1, // Bronze selected by default
      currentPrize: 0,
      sellPrice: 0,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      // Get responsive dimensions
      width:
        belt.dimensions?.[deviceSize]?.width ||
        belt.dimensions?.default?.width ||
        (belt.id === 0 ? 77 : 99),
      height:
        belt.dimensions?.[deviceSize]?.height ||
        belt.dimensions?.default?.height ||
        (belt.id === 0 ? 69 : 79),
    }));
  });
  const [notificationReadLoader, setNotificationReadLoader] = useState(false);
  const [numberOfBelts, setNumberOfBelts] = useState("0");
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [saleBeltModal, setSaleBeltModal] = useState(false);
  const [showAcceptLoader, setAcceptLoader] = useState(false);
  const [profileData, setProfileData] = useState(null);
  // These are now declared above for proper scoping

  const loadingMore = hookLoading.loadMore;
  const allNotificationsLoaded = pagination.allLoaded;

  const getNotificationList = useCallback(
    async (accessToken, loadMore = false, isInitial = false) => {
      try {
        if (isInitial) {
          setShowLoader(true);
        }

        await fetchNotifications(accessToken, loadMore);
      } catch (error) {
        console.error("Error in getNotificationList:", error);
        toast.error(error.message || "Failed to fetch notifications");
      } finally {
        setShowLoader(false);
        setNotificationReadLoader(false);
        setShowChangesLoader(false);
      }
    },
    [fetchNotifications]
  );

  // Belt purchase cost in tokens (what you PAY to BUY a belt)
  const beltPurchaseRates = {
    Bronze: 550,
    Silver: 5500,
    Gold: 55000,
    Platinum: 550000,
  };

  const paymentBeltExchangeAPI = async (accessToken) => {
    try {
      const response = await fetchPaymentBeltExchange(accessToken);
      if (response.statusCode === 200) {
        const arr = [...arrBeltMedalType];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = beltPurchaseRates.Bronze;
            item.sellPrice = Number(response.sellRates.bronze);
          } else if (item.title === "Silver") {
            item.currentPrize = beltPurchaseRates.Silver;
            item.sellPrice = Number(response.sellRates.silver);
          } else if (item.title === "Gold") {
            item.currentPrize = beltPurchaseRates.Gold;
            item.sellPrice = Number(response.sellRates.gold);
          } else if (item.title === "Platinum") {
            item.currentPrize = beltPurchaseRates.Platinum;
            item.sellPrice = Number(response.sellRates.platinum);
          }
        });
        setArrBeltMedalType(arr);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const checkUserBalanceAPI = async (userAccessToken) => {
    try {
      const data = await fetchUserBalance(userAccessToken);

      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      if (data) {
        setUserBalanceData(responseBody);
        const belts = responseBody?.belts;

        const arr = [...arrBeltMedalType];

        // Only process belts if they exist
        if (belts) {
          arr.map((item) => {
            if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
            else if (item.title === "Silver") item.value = Number(belts.silver || 0);
            else if (item.title === "Gold") item.value = Number(belts.gold || 0);
            else if (item.title === "Platinum")
              item.value = Number(belts.platinum || 0);
          });
        }
        setArrBeltMedalType(arr);
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleProfileUpdate = async () => {
    if (!profileData) {
      toast.error("Profile data not loaded");
      return;
    }

    const updatedPlayGames = [
      ...(profileData?.playedGames || []),
      {
        eventId: challengeDetails?.eventDetails?.eventID,
        gameTitle: challengeDetails?.eventDetails?.gameTitle,
      },
    ];
    const updatedChallenged = [
      ...(profileData?.challenged || []),
      {
        eventId: challengeDetails?.eventDetails?.eventID,
        gameTitle: challengeDetails?.eventDetails?.gameTitle,
      },
    ];

    const username = userData.username;
    const params = {
      username,
      accessToken,
      challenged: updatedChallenged,
    };

    try {
      const response = await fetch(
        `${base_url}${endpoints.auth.updateProfile}`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ body: params }),
        }
      );

      let data = await response.json();
      data = parseResponseBody(data);
      if (response.status === 200) {
        toast.success("User profile updated successfully");
      } else {
        toast.error(data.body.error);
      }
    } catch (error) {
      toast.error("Failed to update user profile");
    }
  };

  const fetchUserProfileData = async (accessToken) => {
    try {
      const response = await fetch(`${base_url}${endpoints.auth.userProfile}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken }),
      });

      let data = await response.json();
      data = parseResponseBody(data);
      if (response.status === 200) {
        setProfileData(data.body);
      } else {
        toast.error("Failed to fetch user profile data");
      }
    } catch (error) {
      toast.error("Failed to fetch user profile data");
    }
  };

  const handleNotificationResponse = async (id) => {
    // No loader needed - optimistic update handles UI immediately
    try {
      await markAsRead(accessToken, id, refreshAllNotificationCounts);
      // The hook handles state updates automatically with optimistic update
      // refreshAllNotificationCounts is called automatically after API success
    } catch (error) {
      console.error("Error marking notification as read:", error);
      // Error handling is done in the hook with rollback
    }
  };

  const handleSessionInvite = async (encodedSession) => {
    try {
      const challengerNotificationId = await sendInvite(
        accessToken,
        encodedSession
      );
      if (challengerNotificationId) {
        setChallengeID(challengerNotificationId);
        setShowPendingNotifications(true);
      }
    } catch (error) {
      console.error("Failed to send invite:", error);
      toast.error("Invalid session data.");
    }
  };

  const renderChallengeItem = ({ item, index }) => {
    return (
      <>
        <ChallengeItem
          item={item}
          accessToken={accessToken}
          index={index}
          deviceSize={deviceSize}
          selectedButton={selectedButton}
          navigation={navigation}
          challengeID={challengeID}
          setChallengeID={setChallengeID}
          getNotificationList={getNotificationList}
          handleNotificationResponse={handleNotificationResponse}
          setShowNotificationDetails={setShowUpdateEventNotification}
          setChallengeItem={setChallengeItem}
          setChangeToCallOutTooltip={setChangeToCallOutTooltip}
          setTooltipPosition={setTooltipPosition}
          setChangeCostTooltip={setChangeCostTooltip}
          setChangeCostTooltipPosition={setChangeCostTooltipPosition}
          setShowPendingNotifications={setShowPendingNotifications}
          notificationReadLoader={notificationReadLoader}
          setConfirmCheckInLoader={setConfirmCheckInLoader}
          confirmCheckInLoader={confirmCheckInLoader}
          setChallengeDetails={setChallengeDetails}
          setUpdatedEventDetails={setUpdatedEventDetails}
          setPreviousEventDetails={setPreviousEventDetails}
          setUpdatedEventEventId={setUpdatedEventEventId}
          setUpdatedEventNotificationId={setUpdatedEventNotificationId}
          setShowEventsDetailsUpdatedModal={setShowEventsDetailsUpdatedModal}
          setShowChangesApprovedModal={setShowChangesApprovedModal}
          setShowChangesRejectedModal={setShowChangesRejectedModal}
          showChangesLoader={showChangesLoader}
          challengeDetails={challengeDetails}
          setShowAcceptModal={setShowAcceptModal}
          showAcceptModal={showAcceptModal}
          setCornfirmPurchaseBeltModal={setCornfirmPurchaseBeltModal}
          setAcceptLoader={setAcceptLoader}
          handleProfileUpdate={handleProfileUpdate}
          markAsSeenById={markAsSeenById}
          refreshCounts={refreshAllNotificationCounts}
          updateNotificationStatus={updateNotificationStatus}
          isHighlighted={highlightedNotificationId === item.notificationId}
        />
      </>
    );
  };

  useEffect(() => {
    if (selectedTab) {
      if (selectedTab === "Organised") {
        setSelectedButton("I've Organised");
      } else if (selectedTab === "Challenges") {
        setSelectedButton("Challenges");
      } else {
        setSelectedButton("Im Watching");
      }
    }
  }, [selectedTab]);

  // Clear highlighting after 10 seconds
  useEffect(() => {
    if (highlightedNotificationId) {
      const timer = setTimeout(() => {
        setHighlightedNotificationId(null);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [highlightedNotificationId]);

  useEffect(() => {
    if (selectedButton && trackTabVisit) {
      trackTabVisit(selectedButton);
    }
  }, [selectedButton, trackTabVisit]);

  useEffect(() => {
    if (updateNotification) {
      setNotificationReadLoader(false);
    }
  }, [updateNotification]);

  // Use ref to track current selected button without causing re-renders
  const selectedButtonRef = useRef(selectedButton);

  // Update ref when selectedButton changes
  useEffect(() => {
    selectedButtonRef.current = selectedButton;
  }, [selectedButton]);

  // Real-time notification processing - simplified with count refresh
  useEffect(() => {
    if (!newNotification) return;

    const notificationData = newNotification.data || newNotification;
    const notificationId = notificationData.notificationId || notificationData.id;

    console.log("📱 Real-time notification received:", {
      id: notificationId,
      category: notificationData.category,
      type: notificationData.type || newNotification.type,
      data: notificationData
    });

    // Add real-time notification to hook state
    if (notificationData.category && notificationId) {
      addRealTimeNotification(notificationData);

      // Refresh all notification counts after socket notification
      console.log("🔄 Refreshing notification counts after socket notification");
      refreshAllNotificationCounts();
    }
  }, [newNotification, addRealTimeNotification, refreshAllNotificationCounts]);

  // REMOVED: Auto-update logic for marking notifications as seen when switching tabs
  // This has been replaced with manual marking when user clicks on notification buttons
  //
  // useEffect(() => {
  //   console.log("🔄 Tab switched to:", selectedButton);
  //
  //   const markSeenAndRefreshCounts = async (category) => {
  //     await handleMarkAsSeen(category);
  //     // Refresh counts after marking as seen
  //     if (refreshCounts) {
  //       console.log(`🔄 Refreshing counts after marking ${category} as seen`);
  //       setTimeout(() => refreshCounts(), 200); // Small delay to ensure backend is updated
  //     }
  //   };
  //
  //   if (selectedButton === "I've Organised") {
  //     markSeenAndRefreshCounts(NOTIFICATION_CATEGORIES.ORGANISER);
  //   } else if (selectedButton === "Challenges") {
  //     markSeenAndRefreshCounts(NOTIFICATION_CATEGORIES.CHALLENGER);
  //   } else if (selectedButton === "Im Watching") {
  //     markSeenAndRefreshCounts(NOTIFICATION_CATEGORIES.AUDIENCE);
  //   }
  // }, [selectedButton, handleMarkAsSeen, refreshCounts]);

  useEffect(() => {
    async function getLoginUserData() {
      const data = await getLoginData();
      if (data != null) {
        setUserData(data);
        if (data.AccessToken) {
          setAccessToken(data.AccessToken);
          getNotificationList(data.AccessToken, false, true);
          checkUserBalanceAPI(data.AccessToken);
          fetchUserProfileData(data.AccessToken);
          paymentBeltExchangeAPI(data.AccessToken);
        }
      } else {
        console.log("No login data found");
        // navigation.dispatch(StackActions.replace(AppScreens.LoginWebScreen));
      }
    }
    getLoginUserData();
  }, []);

  useEffect(() => {
    if (accessToken && session) {
      handleSessionInvite(session);
    }
  }, [accessToken, session]);

  useFocusEffect(
    React.useCallback(() => {
      if (paramSelectedButton) {
        setSelectedButton(paramSelectedButton);
      }
    }, [paramSelectedButton])
  );

  // Silent background refresh when the tab gains focus
  // Only refreshes data without showing loading skeleton for better UX
  const isInitialMount = useRef(true);
  useFocusEffect(
    React.useCallback(() => {
      // Skip on initial mount since the mount useEffect already fetches data
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }

      async function silentRefreshData() {
        const data = await getLoginData();
        if (data?.AccessToken) {
          // Silent refresh: isInitial = false means no loading skeleton shown
          getNotificationList(data.AccessToken, false, false);
        }
      }
      silentRefreshData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  );

  // Check for pending challenge accept after token purchase
  useEffect(() => {
    if (!accessToken) return;

    console.log('🔍 Notifications: Checking for pending challenge', {
      url: window.location.href,
      accessToken: accessToken ? 'present' : 'missing'
    });

    const pendingChallenge = getPendingChallengeAccept();
    if (pendingChallenge) {
      console.log('🎯 Found pending challenge accept, auto-resuming:', pendingChallenge);
      // Clear the stored context
      clearPendingChallengeAccept();
      // Switch to Challenges tab
      setSelectedButton('Challenges');

      // Set the challenge ID for the modals
      setChallengeID(pendingChallenge.challengeID);

      if (pendingChallenge.needsBeltPurchase) {
        // User came from belt purchase flow, needs to buy belts with new tokens
        console.log('🔔 Opening Belt Purchase modal first');
        setPendingChallengeAfterBelt(true);  // Remember to open challenge after belts
        setCornfirmPurchaseBeltModal(true);
      } else {
        // Open the challenge details modal directly
        console.log('🔔 Opening Challenge Details popup');
        setShowPendingNotifications(true);
      }

      // Clean up URL params after processing
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [accessToken]);

  return (
    <KeyboardAvoidingView style={{ flex: 1 }} behavior="padding">
      <TouchableWithoutFeedback
        onPress={() => {
          setChangeToCallOutTooltip(false);
          setChangeCostTooltip(false);
          Keyboard.dismiss();
        }}
      >
        <View
          style={{
            flex: 1,
            gap: 16,
          }}
        >
          <ScreenBGGradientView />
          <Header
            btnSearchTapped={() => {
              navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
            }}
            btnWalletTapped={() => { }}
            btnStartTutorialTapped={() => { }}
            btnMessageTapped={() => { }}
            btnNotificationTapped={() => { }}
            btnProfileTapped={() => { }}
          />
          <View
            style={{
              width: "100%",
            }}
          >
            <NotificationHeader
              selectedButton={selectedButton}
              setSelectedButton={setSelectedButton}
              organizerUnreadMessages={hookUnreadCounts.organizer}
              challengerUnreadMessages={hookUnreadCounts.challenger}
              watchingUnreadMessages={hookUnreadCounts.watching}
            />
          </View>
          {showLoader ? (
            <NotificationSkeleton />
          ) : (
            <ScrollView showsVerticalScrollIndicator={false}>
              <View
                style={{
                  width: "100%",
                }}
              >
                <FlatList
                  data={
                    selectedButton === "I've Organised"
                      ? arrIveOrganizedList
                      : selectedButton === "Challenges"
                        ? arrChallengeList
                        : selectedButton === "Im Watching"
                          ? arrWatchingList
                          : null
                  }
                  onEndReached={() =>
                    getNotificationList(accessToken, true, false)
                  }
                  onEndReachedThreshold={0.5}
                  ListFooterComponent={
                    loadingMore ? (
                      <View style={{ padding: 20 }}>
                        <ActivityIndicator
                          size="small"
                          color={AppColors.white}
                        />
                      </View>
                    ) : null
                  }
                  keyExtractor={(item, index) => item.notificationId + index}
                  renderItem={renderChallengeItem}
                  ListEmptyComponent={
                    !showLoader ? (
                      <NoDataFound
                        marginTop={20}
                        color={AppColors.gray_C3C3C3}
                      />
                    ) : null
                  }
                />
                {changeToCallOutTooltip && (
                  <CreateEventTooltip
                    tooltipStyle={{
                      zIndex: 10,
                      padding: 10,
                      top: tooltipPosition.top,
                      left: tooltipPosition.left,
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.2,
                      shadowRadius: 5,
                      elevation: 5,
                    }}
                    content={
                      <View style={{ paddingHorizontal: 15 }}>
                        <Text
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            marginBottom: 10,
                          }}
                        >
                          Switch to Kall-Out Event
                        </Text>
                        <Text style={{ fontSize: 14, marginBottom: 10 }}>
                          You haven't reached the required ticket sales for an
                          exclusive event. You can switch to a public Kall-Out
                          Event instead.
                        </Text>
                        <Text
                          style={{
                            fontWeight: "bold",
                            fontSize: 14,
                            marginBottom: 5,
                          }}
                        >
                          Please note:
                        </Text>
                        <View style={{ paddingLeft: 10 }}>
                          <Text style={{ fontSize: 14, marginBottom: 5 }}>
                            • Only ticket holders can use the chat feature
                            during the stream.
                          </Text>
                          <Text style={{ fontSize: 14, marginBottom: 5 }}>
                            • Ticket holders will be refunded 50% of the ticket
                            price.
                          </Text>
                          <Text style={{ fontSize: 14, marginBottom: 5 }}>
                            • Only ticket holders will have access to watch the
                            recording of this event.
                          </Text>
                          <Text style={{ fontSize: 14 }}>
                            • Ensure you're connected to either YouTube or
                            Twitch and have checked-in at least 60 minutes
                            before the event starts.
                          </Text>
                        </View>
                      </View>
                    }
                    closeImage={AppImages.icCloseWhiteSvg}
                    closeBtnMargin={0}
                    maxHeight={295}
                    width={284}
                    visible={changeToCallOutTooltip}
                    setVisible={setChangeToCallOutTooltip}
                    boxViewStyle={{
                      borderWidth: 0,
                      padding: 0,
                    }}
                  />
                )}
                {changeCostTooltip && (
                  <CreateEventTooltip
                    tooltipStyle={{
                      zIndex: 10,
                      padding: 10,
                      top: changeCostTooltipPosition.top,
                      left: changeCostTooltipPosition.left,
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.2,
                      shadowRadius: 5,
                      elevation: 5,
                    }}
                    content={
                      "You haven’t reached the required number of ticket sales for your event to go ahead as an exclusive event. To proceed, you can cover the remaining cost using your tokens. "
                    }
                    closeImage={AppImages.icCloseWhiteSvg}
                    closeBtnMargin={0}
                    maxHeight={295}
                    width={284}
                    bottom={-132}
                    visible={changeCostTooltip}
                    setVisible={setChangeCostTooltip}
                    boxViewStyle={{
                      borderWidth: 0,
                      padding: 0,
                    }}
                  />
                )}
              </View>
            </ScrollView>
          )}
          {showEventsDetailsUpdatedModal && (
            <EventsDetailsUpdatedModal
              showModal={showEventsDetailsUpdatedModal}
              setShowModal={setShowEventsDetailsUpdatedModal}
              eventID={updatedEventEventId}
              onClose={() => {
                setShowEventsDetailsUpdatedModal(false);
              }}
              updatedEventDetails={updatedEventDetails}
              previousEventDetails={previousEventDetails}
              accessToken={accessToken}
              notificationId={updatedEventNotificationId}
              updateNotificationStatus={(notifId, status) => {
                // Update the notification status using the hook's action
                updateNotificationStatus(notifId, { actionStatus: status });
              }}
            />
          )}
          {showChangesApprovedModal && (
            <ChangesApprovedModal
              showModal={showChangesApprovedModal}
              setShowModal={setShowChangesApprovedModal}
              eventID={updatedEventEventId}
              onClose={() => setShowChangesApprovedModal(false)}
            />
          )}
          {showChangesRejectedModal && (
            <ChangesRejectedModal
              showModal={showChangesRejectedModal}
              setShowModal={setShowChangesRejectedModal}
              eventID={updatedEventEventId}
              onClose={() => setShowChangesRejectedModal(false)}
            />
          )}
          {showPendingNotifications && (
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
              <MobileNotificationDetails
                showModal={showPendingNotifications}
                setShowModal={setShowPendingNotifications}
                onAcceptPress={() => { }}
                challengeID={challengeID}
                username={userData?.username || ""}
                accessToken={accessToken}
              />
            ) : (
              <NotificationDetails
                showModal={showPendingNotifications}
                setShowModal={setShowPendingNotifications}
                onAcceptPress={() => { }}
                challengeID={challengeID}
                username={userData.username}
                accessToken={accessToken}
              />
            )
          )}
          {showAcceptModal && (
            <ChallengeAcceptModal
              eventID={challengeItem.details?.eventID}
              showModal={showAcceptModal}
              eventDetails={challengeItem.details}
              setShowModal={setShowAcceptModal}
              setPopup={setShowAcceptModal}
              platformStatus={platformStatus}
            />
          )}
          {cornfirmPurchaseBeltModal && (
            <CornfirmPurchaseBeltModal
              accessToken={accessToken}
              numberOfBelts={numberOfBelts}
              setArrBeltMedalType={setArrBeltMedalType}
              arrBeltMedalType={arrBeltMedalType}
              showModal={cornfirmPurchaseBeltModal}
              setRefreshAPICall={setRefreshAPICall}
              userBalanceData={userBalanceData}
              setShowModal={setCornfirmPurchaseBeltModal}
              eventID={challengeItem?.details?.eventID || challengeItem?.notificationId || challengeID}
              dataSelectedBelt={arrBeltMedalType.find(
                (item) => item.isSelected
              )}
              selectedBelt={(data) => {
                setBeltPurchaseSuccessModal(true);
              }}
              jumpToPurchaseToken={(isNavigate: false) => {
                if (isNavigate) {
                  const eventId = challengeItem?.details?.eventID || challengeItem?.notificationId || challengeID;
                  const pendingChallengeId = challengeItem?.notificationId || challengeID;
                  // Store pending challenge context for auto-resume after payment
                  storePendingChallengeAccept(pendingChallengeId, eventId);
                  navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                    eventID: eventId,
                    type: "notification",
                  });
                  setShowPendingNotifications(false);
                }
              }}
            />
          )}
          {beltPurchaseSuccessModal && (
            <BeltPurchaseSuccessModal
              setSaleBeltModal={setSaleBeltModal}
              arrBeltMedalType={arrBeltMedalType}
              showModal={beltPurchaseSuccessModal}
              setShowModal={(show) => {
                console.log('📦 BeltPurchaseSuccessModal setShowModal called:', {
                  show,
                  pendingChallengeAfterBelt,
                  challengeID,
                  shouldOpenChallenge: !show && pendingChallengeAfterBelt && challengeID
                });
                setBeltPurchaseSuccessModal(show);
                // After closing success modal, open challenge popup if pending
                if (!show && pendingChallengeAfterBelt && challengeID) {
                  console.log('🎉 Belt purchase complete, opening challenge popup');
                  setPendingChallengeAfterBelt(false);
                  setTimeout(() => {
                    setShowPendingNotifications(true);
                  }, 300); // Small delay for modal transition
                }
              }}
              numberOfBelts={numberOfBelts}
              dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
            />
          )}
          {showAcceptLoader ||
            notificationReadLoader ||
            confirmCheckInLoader ? (
            <ShowLoader
              showIndicater={
                showAcceptLoader ||
                notificationReadLoader ||
                confirmCheckInLoader
              }
            />
          ) : null}
        </View>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );
}
